import { FlexListProps } from '@procore/core-react/dist/_typedoc/FlexList/FlexList.types.json';
import * as React from 'react';
export default {
  FlexListProps,
  React
};